/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationPoloDetailViewModel } from "../types/CourseRegistrationPoloDetailViewModel.ts";

export const courseRegistrationPoloDetailViewModelSchema = z.object({
  poloId: z
    .number()
    .int()
    .describe("ID do polo vinculado à matrícula. Opcional.")
    .nullish(),
  poloName: z
    .string()
    .describe("Nome do polo vinculado à matrícula. Opcional.")
    .nullish(),
  personFullName: z
    .string()
    .describe("Nome completo da pessoa matriculada.")
    .nullish(),
  courseName: z.string().describe("Nome do curso da matrícula.").nullish(),
  registerDate: z
    .string()
    .datetime()
    .describe("Data de registro da matrícula. Opcional.")
    .nullish(),
  personAddress: z
    .string()
    .describe("Endereço formatado da pessoa (HTML). Opcional.")
    .nullish(),
  personCpf: z
    .string()
    .describe("CPF da pessoa matriculada. Opcional.")
    .nullish(),
  personRg: z
    .string()
    .describe("RG da pessoa matriculada. Opcional.")
    .nullish(),
  personPassaportNumber: z
    .string()
    .describe("Número de passaporte da pessoa. Opcional.")
    .nullish(),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa vinculada à matrícula. Opcional.")
    .nullish(),
  personId: z.optional(z.number().int().describe("ID da pessoa matriculada.")),
}) as unknown as ToZod<CourseRegistrationPoloDetailViewModel>;
